import type {RouteRecordRaw} from "vue-router";

export const routeName = 'OutgoingList';

export const route: RouteRecordRaw = {
    name: routeName,
    path: '',
    component: () => import('@/pages/DocumentList'),
    props: {
        status: 'outgoing',
    },
    meta: {
        isHide: true,
    }
};